import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Paper,
  Grid,
  Button,
  CircularProgress,
  Snackbar,
  Alert
} from '@mui/material';
import axios from 'axios';
import { API_URL } from '../../../common/Constants';
import Cookies from '../../../common/Cookies';

const ContactInfoSection = ({ accountData, handleChange, onSave }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSaveContact = async () => {
    setIsSaving(true);

    try {
      const contactData = {
        firstName: accountData.firstName,
        lastName: accountData.lastName,
        company: accountData.company,
        email: accountData.email,
        phone: accountData.phone
      };

      const response = await axios.post(`${API_URL}/account/contact/save`, contactData, {
        headers: {
          'Authorization': `Bearer ${Cookies.getJwtToken() || localStorage.getItem('token') || 'dummy-token'}`
        }
      });

      if (response.data.success) {
        showSnackbar('✅ Contact information saved successfully!', 'success');
        // Show testing warning if present
        if (response.data.testingWarning) {
          setTimeout(() => {
            showSnackbar(response.data.testingWarning, 'warning');
          }, 2000);
        }
        if (onSave) onSave();
      } else {
        showSnackbar('❌ Error: ' + response.data.message, 'error');
      }
    } catch (error) {
      console.error('Error saving contact info:', error);
      showSnackbar('❌ Error saving contact information', 'error');
    } finally {
      setIsSaving(false);
    }
  };
  return (
    <Paper elevation={0} sx={{ p: 3, height: '100%' }}>
      <Typography variant="h6" gutterBottom sx={{ textAlign: 'left' }}>Contact Information</Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: { xs: '100%', sm: 400, md: 500 }, ml: 0 }}>
        <TextField
          fullWidth
          label="First Name"
          variant="outlined"
          value={accountData.firstName}
          onChange={(e) => handleChange('contact', 'firstName', e.target.value)}
        />

        <TextField
          fullWidth
          label="Last Name"
          variant="outlined"
          value={accountData.lastName}
          onChange={(e) => handleChange('contact', 'lastName', e.target.value)}
        />

        <TextField
          fullWidth
          label="Company"
          variant="outlined"
          value={accountData.company}
          onChange={(e) => handleChange('contact', 'company', e.target.value)}
        />

        <TextField
          fullWidth
          label="Email"
          type="email"
          variant="outlined"
          value={accountData.email}
          onChange={(e) => handleChange('contact', 'email', e.target.value)}
        />

        <TextField
          fullWidth
          label="Phone Number"
          variant="outlined"
          value={accountData.phone}
          onChange={(e) => handleChange('contact', 'phone', e.target.value)}
        />

        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveContact}
          disabled={isSaving}
          startIcon={isSaving && <CircularProgress size={20} color="inherit" />}
          fullWidth
          sx={{ mt: 2 }}
        >
          {isSaving ? 'Saving...' : 'Save Contact Information'}
        </Button>
      </Box>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default ContactInfoSection;